/**
 * Phase 2D · /billing/cancel — minimal stop-state.
 *
 * Copy pass (Jun 20): if the user already has a paid term, reassure them
 * it continues until the expiry date.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

import { authService } from "@/services/authService";

const formatExpiry = (iso) => {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return "";
        return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
    } catch { return ""; }
};

export default function Cancel() {
    const [me, setMe] = useState(null);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await authService.http.get("/billing/me");
                if (!cancelled) setMe(r.data);
            } catch { /* not signed in or no term; fine — line is conditional */ }
        })();
        return () => { cancelled = true; };
    }, []);

    const showActiveTerm = me && me.subscription_until && !me.lapsed;
    const expiry = showActiveTerm ? formatExpiry(me.subscription_until) : "";

    return (
        <div data-testid="billing-cancel-page" className="min-h-screen bg-[#f6f7f6] text-[#0e1416] flex items-center justify-center p-6">
            <div className="bg-[#ffffff] border border-[#d8dcdd] p-8 max-w-[520px] w-full text-center">
                <XCircle className="text-[#5a6669] mx-auto" size={36} strokeWidth={1.5} />
                <h2 className="mt-4 text-[22px] font-medium">Checkout cancelled</h2>
                <p className="tc-mono text-[11.5px] text-[#5a6669] mt-2">
                    No charge was made. Your term pass is unchanged.
                </p>
                {showActiveTerm && expiry && (
                    <p data-testid="billing-cancel-active-term"
                       className="tc-mono text-[11.5px] text-[#0e1416] mt-3 leading-[1.6]">
                        If you have an existing paid term, it continues until <span className="text-[#01696f]">{expiry}</span> as expected.
                    </p>
                )}
                <Link
                    to="/billing"
                    data-testid="billing-cancel-cta"
                    className="mt-6 inline-block tc-mono text-[11.5px] px-4 py-2 border border-[#01696f] text-[#01696f] hover:bg-[#01696f] hover:text-[#ffffff]"
                >
                    Back to billing
                </Link>
            </div>
        </div>
    );
}
